export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6259.9880b928.jpg";